import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import MoveGroupsAndAppsSvg from '../../../assets/icons/nav/move-groups-apps.svg?raw';

export const MoveGroupsAndAppsIcon = (props) => <CustomSVG svg={MoveGroupsAndAppsSvg} preserveColors {...props} />;
